/**
 * SB6-AUTH-ADDR-01 — country reference list hook.
 *
 * Pulls `GET /api/auth/v1/countries` once and caches indefinitely
 * (Christian's directive: "Loads the country list once, caches forever").
 * Used by the address-form typeahead in `AddressSection.tsx`.
 */
import { useQuery } from "@tanstack/react-query";
import { authFetch } from "./authFetch.js";

export interface CountryEntry {
  alpha2: string;
  alpha3: string;
  nameEn: string;
  nameDe: string;
}

interface CountriesResponse {
  items: CountryEntry[];
}

const COUNTRIES_QUERY_KEY = ["account", "countries"] as const;

export function useCountries() {
  return useQuery<CountryEntry[]>({
    queryKey: COUNTRIES_QUERY_KEY,
    queryFn: async () => {
      const res = await authFetch<CountriesResponse>("/countries");
      return res.items;
    },
    // Effectively cache forever — ISO country list mutates on decade
    // boundaries. A page reload picks up changes via the fresh fetch.
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
